import { useConfig } from "@/context/use-context";
import { useQuery } from "@tanstack/react-query";
import API from "./api";

interface AlertResponse {
	creation_date: string;
	customer_id: string;
	email_address: string | null;
	email_enabled: boolean;
	phone_number: string | null;
	push_enabled: boolean;
	sms_enabled: boolean;
}

export const fetchSettings = async ({
	BEARER_TOKEN,
}: { BEARER_TOKEN: string }): Promise<AlertResponse> => {
	const response = await API.get("/notifications/settings", {
		headers: {
			Authorization: `Bearer ${BEARER_TOKEN}`,
		},
	});
	return response.data;
};

// React Query Hook
export const useSettings = () => {
	const config = useConfig();

	return useQuery({
		queryKey: ["settings"],
		queryFn: () => fetchSettings({ BEARER_TOKEN: config.bearerToken }),
	});
};
